import { message } from "antd";
import { get } from "lodash";

export const onSuccess = (reload, currentForm, callBack, messageText) => {
  currentForm.resetFields();
  reload();
  callBack();
  message.success(messageText);
};

export const onError = (error, keys, defaultMessage) => {
  const errors = keys.reduce((acc, key) => {
    const err = get(error.response.data, key, undefined);
    if (err) acc.push(err);
    return acc;
  }, []);
  if (errors) errors.map(e => message.error(e));
  else message.error(defaultMessage);
};
